"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChp = function IconChp(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M34.63 22.32c5.71 0 10.34 4.63 10.34 10.34S40.34 43 34.63 43s-10.34-4.63-10.34-10.34 4.63-10.34 10.34-10.34m3.577-11.113-30.47 30.47-1.414-1.414L11 35.585l.002-18.527a3.84 3.84 0 0 1 3.838-4.063L15 13l.16-.004a3.84 3.84 0 0 1 2.84 1.25l.12-.125a3.84 3.84 0 0 1 2.72-1.125L21 13l.16-.004a3.84 3.84 0 0 1 2.84 1.25l.12-.125a3.84 3.84 0 0 1 2.72-1.125L27 13l.16-.004a3.84 3.84 0 0 1 2.72 1.125c.459.459.788 1.02.968 1.618l5.945-5.945zM34.63 24.32A8.34 8.34 0 1 0 34.632 41a8.34 8.34 0 0 0-.002-16.681M35 31.5l3.5-1-5.5 9 1-6-3.5 1 6-9zM14.942 14.998a1.84 1.84 0 0 0-1.408.536c-.33.33-.52.772-.536 1.275L13 17v16.586l4-4 .001-12.53a4 4 0 0 1-.003-.352 1.84 1.84 0 0 0-1.766-1.708zm6 0a1.84 1.84 0 0 0-1.408.536c-.31.311-.496.721-.53 1.188l.002.056L19 17v10.586l4-4 .001-6.53a4 4 0 0 1-.003-.352 1.84 1.84 0 0 0-1.766-1.708zm6 0a1.84 1.84 0 0 0-1.408.536c-.31.311-.496.721-.53 1.188l.002.056L25 17v4.586l4-4 .002-.644a1.84 1.84 0 0 0-1.77-1.946zM11 20.97H6v-2h5zm7-11h-2v-4h2zm4 0h-2v-7h2zm4 0h-2v-4h2z"
  })));
};

export { IconChp, IconChp as default };
